module.exports = __webpack_public_path__ + "img/closeIcon.7cf6ab14.svg";